import { render, staticRenderFns } from "./HistoryTalkingMain.vue?vue&type=template&id=455b5b76&scoped=true&"
import script from "./HistoryTalkingMain.vue?vue&type=script&lang=js&"
export * from "./HistoryTalkingMain.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTalkingMain.vue?vue&type=style&index=0&id=455b5b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5b76",
  null
  
)

export default component.exports